// Re-export functions from shared library for convenience
export {
  getCustomFieldDateDisplay,
  getDateDisplay,
  getDateTimeDisplay,
  getFormulaFieldMissingCustomFields,
  getIdeaFieldsWithMissingCustomFieldsAdded,
  getSafeName,
  getSafeUrl,
  isSystemField,
  isValidEmailDomain,
  removeSystemFieldNamePrefix,
} from '@tempo-io/fim3-components';

// Frontend-specific utilities
export const getPortalsBaseUrl = (env: {
  portalsBaseUrl?: string;
  apiBaseUrl?: string;
}): string => {
  const apiBaseUrl = env?.apiBaseUrl ?? '';
  return env?.portalsBaseUrl ?? apiBaseUrl;
};

export const parseViewId = (viewId: string | number | undefined): number => {
  if (viewId === undefined || viewId === null) return 0;

  const parsed = typeof viewId === 'string' ? parseInt(viewId, 10) : Number(viewId);

  // Check for NaN, non-finite numbers (Infinity, -Infinity), non-integers, and non-positive numbers
  return Number.isNaN(parsed) ||
    !Number.isFinite(parsed) ||
    !Number.isInteger(parsed) ||
    parsed <= 0
    ? 0
    : parsed;
};
